"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const plugin_1 = __importDefault(require("tailwindcss/plugin"));
const colorTags = [
    'rgb(66,133,244)',
    'rgb(156,39,176)',
    'rgb(255,0,127)',
    'rgb(48,41,40)',
    'rgb(255,152,0)',
    'rgb(255,202,40)',
    'rgb(70,210,196)',
    'rgb(76,175,80)',
];
const colorTagPlugin = (0, plugin_1.default)(({ addUtilities }) => {
    const newUtilities = {};
    colorTags.forEach((color, i) => {
        const tag = i + 1;
        newUtilities[`.bg-color-tag-${tag}`] = {
            'background-color': `rgba(${color.replace(/rgb\(|\)/g, '')}, var(--tw-bg-opacity, 1))`
        };
        newUtilities[`.border-color-tag-${tag}`] = {
            'border-color': `rgba(${color.replace(/rgb\(|\)/g, '')}, var(--tw-border-opacity, 1))`
        };
        newUtilities[`.text-color-tag-${tag}`] = {
            color: `rgba(${color.replace(/rgb\(|\)/g, '')}, var(--tw-text-opacity, 1))`
        };
    });
    addUtilities(newUtilities);
});
exports.default = colorTagPlugin;
